(() => {
  const mobile = window.matchMedia('(max-width: 989px)');

  const init = (root) => {
    if (root.dataset.drvResReady) return;
    root.dataset.drvResReady = '1';
    const box = root.querySelector('[data-drv-res-toc]');
    if (!box) return;
    const toggle = box.querySelector('[data-drv-res-toggle]');
    const panel = box.querySelector('[data-drv-res-panel]');
    const links = Array.from(box.querySelectorAll('[data-drv-res-link]'));

    const setOpen = (open) => {
      box.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    };
    toggle.addEventListener('click', () => setOpen(!box.classList.contains('is-open')));
    links.forEach((link) => link.addEventListener('click', () => {
      if (mobile.matches) setOpen(false);
    }));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && box.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    const hint = (scroller) => {
      const update = () => scroller.classList.toggle('has-more', scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 2);
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      return update;
    };
    const updateBox = hint(box);
    const updatePanel = hint(panel);
    toggle.addEventListener('click', () => requestAnimationFrame(updatePanel));
    mobile.addEventListener('change', () => { updateBox(); updatePanel(); });

    if (!('IntersectionObserver' in window)) return;
    const byCard = new Map();
    links.forEach((link) => {
      const card = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (card && root.contains(card)) byCard.set(card, link);
    });

    const show = (link) => {
      links.forEach((l) => {
        if (l === link) l.setAttribute('aria-current', 'true');
        else l.removeAttribute('aria-current');
      });
      const scroller = mobile.matches ? panel : box;
      if (scroller.scrollHeight > scroller.clientHeight) {
        const delta = link.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
        scroller.scrollTo({ top: Math.max(0, scroller.scrollTop + delta - scroller.clientHeight / 2) });
      }
    };

    const visible = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        const cards = Array.from(byCard.keys()).filter((card) => visible.has(card));
        if (cards.length) show(byCard.get(cards[0]));
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    byCard.forEach((_, card) => io.observe(card));
  };

  const start = (scope) => scope.querySelectorAll('[data-drv-res]').forEach(init);
  start(document);
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
